import { type QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { type ReactNode } from 'react';

const QueryContainer = ({ children, queryClient }: { children: ReactNode; queryClient: QueryClient }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export default QueryContainer;
